module.exports = __webpack_public_path__ + "img/GCC_Fullwidth_Home_Banner.9a2b49ef.jpg";